import { createContext, useContext } from "react";
import { ICommandRunnerContext } from "./command-runner-context.interface";

export const CommandRunnerContext = createContext<ICommandRunnerContext>(
  {} as ICommandRunnerContext
);

export const useCommandRunner = () =>
  useContext<ICommandRunnerContext>(CommandRunnerContext);
